// extracted by mini-css-extract-plugin
export default {"wrapper":"Wea","container":"Xea","title":"Yea","carousel":"Zea","review":"afa","name":"bfa","rating":"cfa","heading":"efa","body":"ffa"};
    if(module.hot) {
      // 1721922369179
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  